/** @return {import("fs")} */
const getFs = () => window.nodeModules?.fs;

export default getFs;
